import { render } from "./LocationMenu.vue?vue&type=template&id=2a7b7a74&scoped=true"
import script from "./LocationMenu.vue?vue&type=script&lang=js"
export * from "./LocationMenu.vue?vue&type=script&lang=js"

import "./LocationMenu.vue?vue&type=style&index=0&id=2a7b7a74&lang=css&scoped=true"

import exportComponent from "D:\\courses\\Web Design\\JAVA  SCRIPT\\Vue-js courses\\resturant\\mat-aem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7b7a74"]])

export default __exports__